import ExternalDoorInRowInstallationInformation from './ExternalDoorInRowInstallationInformation';

export default ExternalDoorInRowInstallationInformation;